import { render, staticRenderFns } from "./alarm.vue?vue&type=template&id=41db6f56&scoped=true"
import script from "./alarm.vue?vue&type=script&lang=js"
export * from "./alarm.vue?vue&type=script&lang=js"
import style0 from "./alarm.vue?vue&type=style&index=0&id=41db6f56&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41db6f56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41db6f56')) {
      api.createRecord('41db6f56', component.options)
    } else {
      api.reload('41db6f56', component.options)
    }
    module.hot.accept("./alarm.vue?vue&type=template&id=41db6f56&scoped=true", function () {
      api.rerender('41db6f56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bigScreen/components/alarm.vue"
export default component.exports